/* eslint-disable function-paren-newline */
/* eslint-disable comma-dangle */
/* eslint-disable implicit-arrow-linebreak */
import { useEffect, useState } from 'react';
import api from 'services/api';
import { useSelector } from 'react-redux';
import { useRequest } from './useRequest';
import { useParams, useLocation } from 'react-router-dom';
import CycleService from 'services/CycleService';

export function usePopulation() {
  const [lots, setLots] = useState([]);
  const [pondCycles, setPondCycles] = useState([]);
  const location = useLocation();
  const { id } = useParams();

  const selectedCycle = useSelector(
    (state) => state.selectedCycle.selectedCycle
  );

  const disable = useSelector((state) => state.disable.disable);

  const apiRequest = async (data) => {
    if (id) {
      await api.put(`/populations/${id}`, data[0]);
    } else {
      await api.post('/populations', [...data]);
    }
  };

  const { request, openProgress } = useRequest(apiRequest, '/populations');

  const fetchLots = () => {
    api
      .get('/lots')
      .then((lots_) =>
        setLots(lots_.data.filter((lot) => lot.size_remain > 0))
      );
  };

  useEffect(() => {
    async function loadPondCycles() {
      try {
        const updatedPondCycles = await CycleService.pondsAvailableToPopulate(
          selectedCycle.id
        );
        setPondCycles(updatedPondCycles);
      } catch (error) {
        throw new Error(error);
      }
    }
    loadPondCycles();
  }, [selectedCycle]);

  useEffect(() => {
    fetchLots();
  }, []);

  return {
    lots,
    setLots,
    pondCycles,
    setPondCycles,
    request,
    openProgress,
    id,
    location,
    disable,
    fetchLots,
  };
}
